import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SaveOutlined, UserOutlined } from '@ant-design/icons';
import { Button, DatePicker, Row, Col, Input, Drawer, Space, TreeSelect } from 'antd';
import { Form } from '@ant-design/compatible';
import {
    isValidDateForm,
    _newLine,
    CustomerScheduleType,
    makeTree,
    telesaleFollowStatuses
} from '@/utils/helpers';
import { isMobile } from 'react-device-detect';
import { assignedTelesaleResult } from '@/redux/actions/telesaleFollowUpActions';
import BaseRadioList from '@/components/Elements/BaseRadios';
import BaseSelect from '@/components/Elements/BaseSelect';
import { fetchFilters } from '@/redux/actions/filterActions';

class TelesaleAssignedResultForm extends Component {
    state = {
        isLoading: false,
        showResultFields: false,
        scheduleOption: null,
    };

    componentDidMount() {
        this.props.fetchFilters();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.currentItem !== this.props.currentItem) {
            this.setState({
                showResultFields: Boolean(this.props.currentItem?.status),
                scheduleOption: null,
            });
        }
    }

    onChangeStatus = (value) => {
        this.setState({
            showResultFields: Boolean(value),
            scheduleOption: null,
        });
    };

    onChangeSchedule = (value) => {
        this.setState({ scheduleOption: value });
    };

    onChangeScheduleType = (value) => {
        const needTime = !['CHUADATDUOCLICH', 'CHUAXACDINHLICH'].includes(value);
        if (!needTime) {
            this.props.form.setFieldsValue({ time: null });
        }
    };

    prepareSubmitData = (values) => {
        const data = { ...values };

        data.schedule_records = {
            name: data.name,
            time: data.time ? data.time.format('YYYY-MM-DD HH:mm') : null,
            note: data.note,
        };

        data.retele_records = {
            deadline: data.deadline ? data.deadline.format('YYYY-MM-DD HH:mm') : null,
        };

        delete data.name;
        delete data.time;
        delete data.note;
        delete data.deadline;

        if (data.handled_at) {
            data.handled_at = data.handled_at.format('YYYY-MM-DD HH:mm');
        }

        return data;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { form, currentItem } = this.props;

        form.validateFields(async (err, values) => {
            if (err || !currentItem) return;

            this.setState({ isLoading: true });

            try {
                const submitData = this.prepareSubmitData(values);
                await this.props.assignedTelesaleResult(currentItem.id, submitData);
                this.handleCancel();
            } catch {
                this.setState({ isLoading: false });
            }
        });
    };

    handleCancel = () => {
        this.props.loadData();
        this.props.form.resetFields();
        this.props.onCancel();
        this.setState({
            isLoading: false,
            showResultFields: false,
            scheduleOption: null,
        });
    };

    renderScheduleFields() {
        const { getFieldDecorator } = this.props.form;
        const { scheduleOption } = this.state;

        if (scheduleOption === 'schedule') {
            return (
                <>
                    <Col xs={24} md={12}>
                        <Form.Item label="Kiểu lịch hẹn">
                            {getFieldDecorator('name', {
                                rules: [{
                                    required: true,
                                    message: 'Vui lòng chọn!'
                                }],
                                initialValue: null,
                                getValueFromEvent: (value) => value,
                            })(
                                <BaseSelect
                                    options={CustomerScheduleType}
                                    showSearch
                                    placeholder="Chọn kiểu lịch"
                                    onChange={this.onChangeScheduleType}
                                />
                            )}
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label="Thời gian">
                            {getFieldDecorator('time', {
                                rules: [{
                                    required: true,
                                    message: 'Vui lòng điền!'
                                }],
                                initialValue: null,
                                getValueFromEvent: (date) => date, // bắt Form lấy đúng moment
                            })(
                                <DatePicker
                                    showTime={{ format: 'HH:mm' }}
                                    format="DD/MM/YYYY HH:mm"
                                    style={{ width: '100%' }}
                                />
                            )}
                        </Form.Item>
                    </Col>
                    <Col xs={24}>
                        <Form.Item label="Ghi chú">
                            {getFieldDecorator('note')(<Input.TextArea rows={4} />)}
                        </Form.Item>
                    </Col>
                </>
            );
        }

        if (scheduleOption === 'retele') {
            return (
                <Col xs={24}>
                    <Form.Item label="Thời điểm telesale lại">
                        {getFieldDecorator('deadline', {
                            rules: [{
                                required: true,
                                message: 'Vui lòng chọn!'
                            }],
                            initialValue: null,
                            getValueFromEvent: (date) => date,
                        })(
                            <DatePicker
                                showTime={{ format: 'HH:mm' }}
                                format="DD/MM/YYYY HH:mm"
                                style={{ width: '100%' }}
                            />
                        )}
                    </Form.Item>
                </Col>
            );
        }

        return null;
    }

    render() {
        const { visible, currentItem, filterData, form } = this.props;
        const { getFieldDecorator } = form;
        const { isLoading, showResultFields } = this.state;

        const serviceTree = makeTree(filterData?.services || [], 0);

        return (
            <Drawer
                title="Trả kết quả telesale"
                visible={visible}
                width={isMobile ? '100%' : '50%'}
                onClose={this.handleCancel}
                maskClosable={false}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Space>
                            <Button onClick={this.handleCancel}>Huỷ</Button>
                            <Button
                                type="primary"
                                loading={isLoading}
                                onClick={this.handleSubmit}
                                icon={<SaveOutlined />}
                                size='large'
                            >
                                Lưu
                            </Button>
                        </Space>
                    </div>
                }
            >
                <Form layout="vertical">
                    <Row gutter={16} className='mb-4'>
                        <Col xs={24}>
                            <h6>
                                <UserOutlined /> Khách hàng:{' '}
                                <span className="color-primary">
                                    {currentItem?.customer?.full_name} - {currentItem?.customer?.code}
                                </span>
                            </h6>
                        </Col>
                    </Row>

                    <Row gutter={16}>
                        <Col xs={24}>
                            <Form.Item label="Trạng thái telesale">
                                {getFieldDecorator('status', {
                                    initialValue: currentItem?.status,
                                    rules: [{ required: true }],
                                })(
                                    <BaseRadioList
                                        options={[
                                            { value: 1, label: 'Trả kết quả' },
                                            { value: 0, label: 'Chưa trả kết quả' },
                                        ]}
                                        onChange={this.onChangeStatus}
                                    />
                                )}
                            </Form.Item>
                        </Col>

                        {showResultFields && (
                            <>
                                <Col xs={24}>
                                    <Form.Item label="Dịch vụ quan tâm">
                                        {getFieldDecorator('service_id', {
                                            initialValue: currentItem?.service_id,
                                            rules: [{ required: true }],
                                        })(
                                            <TreeSelect
                                                treeData={serviceTree}
                                                treeDefaultExpandAll
                                                showSearch
                                                allowClear
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item label="Thời điểm telesale">
                                        {getFieldDecorator('handled_at', {
                                            initialValue: isValidDateForm(
                                                currentItem?.handled_at,
                                                true
                                            ),
                                            rules: [{ required: true }],
                                        })(
                                            <DatePicker
                                                showTime={{ format: 'HH:mm' }}
                                                format="DD/MM/YYYY HH:mm"
                                                style={{ width: '100%' }}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item label="Trạng thái follow">
                                        {getFieldDecorator('follow_status', {
                                            initialValue: currentItem?.follow_status,
                                            rules: [{ required: true }],
                                        })(
                                            <BaseSelect
                                                options={telesaleFollowStatuses}
                                                placeholder="Trạng thái follow"
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item label="Kết quả telesale">
                                        {getFieldDecorator('result_content', {
                                            initialValue: _newLine(currentItem?.result_content),
                                            rules: [{ required: true }],
                                        })(<Input.TextArea rows={8} />)}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={24}>
                                    <Form.Item label="Ghi chú">
                                        {getFieldDecorator('telesale_note', {
                                            rules: [
                                                {
                                                    required: false,
                                                    message: "Vui lòng điền!",
                                                },
                                            ],
                                            initialValue: _newLine(currentItem?.note),
                                        })(
                                            <Input.TextArea rows={3} />
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item label="Lập lịch">
                                        {getFieldDecorator('scheduleOption', {
                                            initialValue: null,
                                        })(
                                            <BaseRadioList
                                                options={[
                                                    { value: null, label: 'Không áp dụng' },
                                                    { value: 'schedule', label: 'Lịch hẹn' },
                                                    { value: 'retele', label: 'Lịch telesale lại' },
                                                ]}
                                                onChange={this.onChangeSchedule}
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

                                {this.renderScheduleFields()}
                            </>
                        )}
                    </Row>
                </Form>
            </Drawer>
        );
    }
}

const mapStateToProps = (state) => ({
    filterData: state.filterReducer.list,
});

const mapDispatchToProps = (dispatch) => ({
    assignedTelesaleResult: (id, data) => dispatch(assignedTelesaleResult(id, data)),
    fetchFilters: () => dispatch(fetchFilters()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create({ name: 'TelesaleAssignedResultForm' })(TelesaleAssignedResultForm));
